// Gift Card template: keyboard support and ARIA for the amount dropdown
// (the shared variant-selects markup is mouse-only).
(function () {
  'use strict';

  var ITEM = '[data-colors-item]';

  function getItems(root) {
    return Array.prototype.slice.call(root.querySelectorAll(ITEM));
  }

  function getList(root) {
    return root.querySelector('[data-colors]');
  }

  function getCurrent(root) {
    return root.querySelector(ITEM + '.current');
  }

  // The hidden radio a label's `for` points at (focus lands there after a click).
  function isLinkedRadio(root, el) {
    if (!el || !el.id || !el.matches || !el.matches('input')) return false;
    return getItems(root).some(function (item) {
      return item.htmlFor === el.id;
    });
  }

  // Roles, selected state and roving tabindex. Safe to run repeatedly.
  function sync(root) {
    var list = getList(root);
    if (!list) return;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Gift card amount');
    getItems(root).forEach(function (item) {
      var isCurrent = item.classList.contains('current');
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
      item.setAttribute('tabindex', isCurrent ? '0' : '-1');
    });
  }

  function enhance(root) {
    if (root.dataset.giftCardDropdown === 'true') return;
    root.dataset.giftCardDropdown = 'true';

    // True while keyboard focus is (or was, before a re-render) inside the dropdown.
    var hadFocus = false;

    // The hidden radios would otherwise be a second, invisible tab stop.
    var scope = root.closest('.shopify-section') || document;
    scope.querySelectorAll('variant-radios fieldset[data-swatch-grid] input[type="radio"]')
      .forEach(function (radio) {
        radio.setAttribute('tabindex', '-1');
      });

    sync(root);

    function focusCurrent() {
      var current = getCurrent(root);
      if (current) current.focus();
    }

    root.addEventListener('keydown', function (event) {
      var target = event.target;
      if (!target.matches || !target.matches(ITEM)) return;
      hadFocus = true;

      var list = getList(root);
      var expanded = list.classList.contains('expanded');
      var items = getItems(root);
      var index = items.indexOf(target);

      // Enter is already turned into a click by VariantSelects.
      switch (event.key) {
        case ' ':
        case 'Spacebar':
          event.preventDefault();
          target.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          event.preventDefault();
          if (!expanded) {
            var current = getCurrent(root);
            if (current) current.click();
          } else {
            var next = items[index + (event.key === 'ArrowDown' ? 1 : -1)];
            if (next) next.focus();
          }
          break;
        case 'Home':
          if (expanded && items.length) {
            event.preventDefault();
            items[0].focus();
          }
          break;
        case 'End':
          if (expanded && items.length) {
            event.preventDefault();
            items[items.length - 1].focus();
          }
          break;
        case 'Escape':
          if (expanded) {
            event.preventDefault();
            event.stopPropagation();
            list.classList.remove('expanded');
            focusCurrent();
          }
          break;
      }
    });

    // Runs after VariantSelects' own click handler has updated `.current`.
    root.addEventListener('click', function () {
      hadFocus = true;
      setTimeout(function () {
        sync(root);
        if (hadFocus) focusCurrent();
      }, 0);
    });

    root.addEventListener('focusin', function () {
      hadFocus = true;
    });

    root.addEventListener('focusout', function (event) {
      var next = event.relatedTarget;
      // relatedTarget is null when the focused node is removed by a re-render,
      // so only treat a real element outside the dropdown as "focus left".
      if (next && !root.contains(next) && !isLinkedRadio(root, next)) {
        hadFocus = false;
        var list = getList(root);
        if (list) list.classList.remove('expanded');
      }
    });

    // Safety net: focus must never rest on the invisible linked radio.
    document.addEventListener('focusin', function (event) {
      if (hadFocus && isLinkedRadio(root, event.target)) focusCurrent();
    });

    // The product info re-render can replace the dropdown's children.
    new MutationObserver(function () {
      sync(root);
      if (hadFocus) focusCurrent();
    }).observe(root, { childList: true });
  }

  function init() {
    document.querySelectorAll('.colors-container variant-selects').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
